import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { useBootstrap } from "components/store/source";
import withCodesInput from "components/ui/source/shared/withCodesInput";

import Button from "../atoms/Button";
import Text from "../atoms/Text";
import Section from "../layouts/Section";
import Spacer from "../layouts/Spacer";

import ConfirmationCodePopupAction from "./ConfirmationCodePopupAction";

import styles from "../components/Accounts/Accounts.module.scss";

const CodesInput = withCodesInput(React, PropTypes);

function ConfirmationCodeVerificationForm({
  phoneNumber,
  error,
  onCodeEntered,
  onSubmit,
  disableButton,
  onResendClick,
  onAudioClick,
}) {
  const {
    featureFlags: { updatePhoneNumber },
  } = useBootstrap();

  return (
    <Section>
      <Text
        translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.headerEnterVerificationCode"
        types={["h4", "medium"]}
        className={classnames(styles.header, styles.centered_text)}
      />

      <Text types={["subtitles", "red"]}>{error}</Text>
      <Text
        types={["subtitles"]}
        translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.sentVerificationCode"
        interpolation={{ phoneNumber: phoneNumber }}
      />
      <Spacer size="s-3x" />

      <CodesInput
        length={4}
        onCodeEntered={onCodeEntered}
        name="verificationCode"
        required="required"
      />
      <Spacer size="s-4x" />

      <Section type="full-width">
        <Button
          textProps={{
            translateKey:
              "sonder_one.popups.ConfirmationCodeSignInPopup.submit",
            types: ["subtitles"],
          }}
          onClick={onSubmit}
          disabled={disableButton}
          upperCase={false}
        />
      </Section>
      <Spacer size="s-4x" />

      <Section horizontalPosition="center">
        <ConfirmationCodePopupAction
          prompt={
            <Text
              translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.didntGetText"
              types={["subtitles"]}
            />
          }
          cta={
            <Text
              translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.resendSms"
              types={["subtitles"]}
            />
          }
          link="#"
          onClick={onResendClick}
        />
        <Spacer size="s-1x" />
        <ConfirmationCodePopupAction
          prompt={
            <Text
              translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.noSMSoption"
              types={["subtitles"]}
            />
          }
          cta={
            <Text
              translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.callNumber"
              types={["subtitles"]}
            />
          }
          link="#"
          onClick={onAudioClick}
        />
        {updatePhoneNumber ? (
          <div>
            <Spacer size="s-1x" />
            <Section horizontalPosition="center">
              <Text
                translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.wrongNumber"
                types={["subtitles"]}
              />
            </Section>
          </div>
        ) : null}
      </Section>
    </Section>
  );
}

ConfirmationCodeVerificationForm.propTypes = {
  error: PropTypes.string,
  phoneNumber: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onCodeEntered: PropTypes.func.isRequired,
  onResendClick: PropTypes.func.isRequired,
  onAudioClick: PropTypes.func.isRequired,
  disableButton: PropTypes.bool,
};

export default ConfirmationCodeVerificationForm;
